import "./Common/i18n";
import { ThemeProvider } from "styled-components";
import { Theme } from "./Common/Theme";
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import { PortalRoot } from "./Components/PortalRoot";
import { Login } from "./Pages/Login";
import { Register } from "./Pages/Register";
import { ChatView } from "./Pages/ChatView";
import { InvitationPage } from "./Pages/Invitation";
import { RecoilRoot } from "recoil";
import { EnsureLogin } from "./Components/EnsureLogin";
import { EnsureNotLogged } from "./Components/EnsureNotLogged";
import { Navigate } from "react-router-dom";

import { Notifications } from "./Components/Notifications";
import { SuccessPayment } from "./Pages/Auxiliar/SuccessPayment";
import { CancelledPayment } from "./Pages/Auxiliar/CancelledPayment";
import { EnsurePlanPaid } from "./Components/EnsurePlanPaid";
import { StripePricing } from "./Pages/StripePricing";
import { BuyCredits } from "./Pages/BuyCredits";
import { DueDiligencePlans } from "./Pages/DueDiligencePlans";
import { ResetPassword } from "./Pages/ResetPassword";
import { CasesList } from "./Pages/DueDiligence/CasesList";
import { NewCase } from "./Pages/DueDiligence/NewCase";
import { CaseDetails } from "./Pages/DueDiligence/CaseDetails";
import { PaymentSuccess } from "./Pages/DueDiligence/PaymentSuccess";
import { FinalReport } from "./Pages/DueDiligence/FinalReport";
import { ContractsList } from "./Pages/Contracts/ContractsList";
import { ContractDetails } from "./Pages/Contracts/ContractDetails";
import { SearchPage } from "./Pages/SearchPage";
import { MixpanelIdentity } from "./Components/MixpanelIdentity";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <EnsureLogin>
        <PortalRoot />
      </EnsureLogin>
    ),
    children: [
      {
        path: "/",
        element: <EnsurePlanPaid />,
        children: [
          {
            path: "/",
            element: <ChatView />,
          },
          {
            path: "/chat",
            element: <ChatView />,
          },
          {
            path: "/chat/:chatId",
            element: <ChatView />,
          },
          {
            path: "/due-diligence",
            element: <CasesList />,
          },
          {
            path: "/due-diligence/new",
            element: <NewCase />,
          },
          {
            path: "/due-diligence/case/:caseAlias",
            element: <CaseDetails />,
          },
          {
            path: "/due-diligence/case/:caseAlias/report",
            element: <FinalReport />,
          },
          {
            path: "/due-diligence/payment/success",
            element: <PaymentSuccess />,
          },
          {
            path: "/contracts",
            element: <ContractsList />,
          },
          {
            path: "/contracts/:contractId",
            element: <ContractDetails />,
          },
          {
            path: "/search",
            element: <SearchPage />,
          },
        ],
      },
      {
        path: "/choose-plan",
        element: <StripePricing />,
      },
      {
        path: "/buy-credits",
        element: <BuyCredits />,
      },
      {
        path: "/due-diligence-plans",
        element: <DueDiligencePlans />,
      },
      {
        path: "/success-payment",
        element: <SuccessPayment />,
      },
      {
        path: "/cancelled-payment",
        element: <CancelledPayment />,
      },
    ],
  },
  {
    path: "/invitation",
    element: <InvitationPage />,
  },
  {
    path: "/login",
    element: (
      <EnsureNotLogged>
        <Login />
      </EnsureNotLogged>
    ),
  },
  {
    path: "/register",
    element: (
      <EnsureNotLogged>
        <Register />
      </EnsureNotLogged>
    ),
  },
  {
    path: "/reset-password",
    element: (
      <EnsureNotLogged>
        <ResetPassword />
      </EnsureNotLogged>
    ),
  },
  {
    path: "*",
    element: <Navigate to="/" replace />,
  },
]);

function App() {
  return (
    <RecoilRoot>
      <ThemeProvider theme={Theme}>
        <MixpanelIdentity />
        <Notifications />
        <div style={{backgroundColor: "white"}}>
          <RouterProvider router={router} />
        </div>
      </ThemeProvider>
    </RecoilRoot>
  );
}

export default App;
